(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giveaway-page"] && !Shopify.designMode) return;
  try {
    
/**
 * Giveaway Page Interactions
 * Handles scroll reveals, form interactions, and celebration effects
 */
class GiveawayPageAnimations {
  constructor() {
    this.init();
  }

  init() {
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Core initializations
    this.setupScrollReveal();
    this.setupFormEnhancements();
    this.setupCountdown();
    this.initializeParticles();
    this.setupSmoothScroll();
    
    // Trigger hero animations immediately
    this.animateHero();
  }

  /**
   * Animate hero elements on load
   */
  animateHero() {
    if (this.isReducedMotion) return;
    
    const title = document.querySelector('.giveaway-page__title');
    if (title) {
      // Add class to trigger CSS animation
      requestAnimationFrame(() => {
        title.classList.add('animate-in');
      });
    }
  }

  /**
   * Setup Intersection Observer for scroll-triggered reveals
   */
  setupScrollReveal() {
    if (this.isReducedMotion) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          // Stop observing once revealed for performance
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Elements to observe
    const elementsToReveal = document.querySelectorAll([
      '.giveaway-page__apply-highlight',
      '.giveaway-page__step',
      '.giveaway-page__prize-card',
      '.giveaway-page__spec-item'
    ].join(','));

    elementsToReveal.forEach((el, index) => {
      // Add index for staggered delays
      el.style.setProperty('--item-index', index % 4); // Reset index every 4 items
      observer.observe(el);
    });
  }

  /**
   * Enhance form with micro-interactions
   */
  setupFormEnhancements() {
    const form = document.querySelector('.giveaway-page__form-card');
    if (!form) return;

    // Add focus classes for styling hooks
    const inputs = form.querySelectorAll('.field__input, .text-area');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        input.parentElement.classList.add('is-focused');
      });
      
      input.addEventListener('blur', () => {
        input.parentElement.classList.remove('is-focused');
      });
    });

    // Character counter for textarea
    const textarea = form.querySelector('#GiveawayForm-body');
    if (!textarea) return;

    const maxChars = 500; // Assuming 500 char limit
    const counter = document.createElement('div');
    counter.className = 'giveaway-char-counter';
    counter.style.cssText = 'font-size: 12px; margin-top: 4px; text-align: right; transition: color 0.3s;';
    
    const updateCounter = () => {
      const length = textarea.value.length;
      counter.textContent = `${length} characters`;
      
      if (length > maxChars) {
        counter.style.color = 'rgba(255, 59, 48, 0.8)';
      } else if (length > maxChars * 0.8) {
        counter.style.color = 'rgba(255, 149, 0, 0.8)';
      } else {
        counter.style.color = 'rgba(var(--color-foreground, 5, 28, 54), 0.6)';
      }
    };
    
    textarea.addEventListener('input', updateCounter);
    textarea.parentElement.appendChild(counter);
    updateCounter();
  }
  
  /**
   * Setup countdown timer (if deadline exists)
   */
  setupCountdown() {
    const deadlineValue = document.querySelector('.giveaway-page__status-pill--alert .giveaway-page__status-value');
    if (!deadlineValue) return;
    
    // Try to parse the deadline
    const deadlineText = deadlineValue.textContent.trim();
    // This is a simple implementation - you may need to adjust based on your date format
    // Example: "Jan 8 · 11:59pm ET"
    
    // For now, we'll just add a pulsing effect to emphasize urgency
    // A full countdown would require a specific date format
    const pill = deadlineValue.closest('.giveaway-page__status-pill--alert');
    if (pill) {
      // Add urgency class if within 48 hours (you'd calculate this based on actual deadline)
      // pill.classList.add('urgent');
    }
  }
  
  /**
   * Initialize floating particles (desktop only)
   */
  initializeParticles() {
    if (this.isMobile) return;
    
    const background = document.querySelector('.giveaway-page__background');
    if (!background) return;
    
    // Particles are handled via CSS animations on ::before pseudo-element
    // This is more performant than JS-based particle systems
  }
  
  /**
   * Trigger confetti celebration
   */
  triggerConfetti() {
    if (this.isReducedMotion) return;
    
    // Create confetti container
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'giveaway-confetti';
    document.body.appendChild(confettiContainer);
    
    // Confetti colors matching the brand
    const colors = [
      'rgba(1, 219, 243, 0.9)',    // Mad Dad Energy
      'rgba(82, 195, 1, 0.9)',     // Mad Dad Optimism
      'rgba(209, 24, 130, 0.9)',   // Mad Dad Chaos
      'rgba(255, 193, 7, 0.9)',    // Gold
      'rgba(255, 255, 255, 0.9)'   // White
    ];
    
    // Create confetti pieces
    const pieceCount = this.isMobile ? 30 : 50;
    
    for (let i = 0; i < pieceCount; i++) {
      const piece = document.createElement('div');
      piece.className = 'giveaway-confetti__piece';
      
      // Random properties
      const color = colors[Math.floor(Math.random() * colors.length)];
      const left = Math.random() * 100;
      const delay = Math.random() * 0.5;
      const duration = 2 + Math.random() * 2;
      const size = 8 + Math.random() * 8;
      
      piece.style.cssText = `
        --confetti-color: ${color};
        --fall-delay: ${delay}s;
        --fall-duration: ${duration}s;
        left: ${left}%;
        width: ${size}px;
        height: ${size}px;
        border-radius: ${Math.random() > 0.5 ? '50%' : '2px'};
      `;
      
      confettiContainer.appendChild(piece);
    }
    
    // Remove confetti after animation completes
    setTimeout(() => {
      confettiContainer.remove();
    }, 4000);
    
    // Add success celebration class to form status
    const formStatus = document.querySelector('.form-status-list');
    if (formStatus) {
      formStatus.classList.add('success-celebration');
    }
  }
  
  /**
   * Smooth scroll to form when clicking CTA
   */
  setupSmoothScroll() {
    const ctaButtons = document.querySelectorAll('a[href="#GiveawayForm"]');
    ctaButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const form = document.getElementById('GiveawayForm');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Focus first input after scroll
          setTimeout(() => {
            const firstInput = form.querySelector('.field__input');
            firstInput?.focus();
          }, 500);
        }
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new GiveawayPageAnimations();
  });
} else {
  new GiveawayPageAnimations();
}

// Re-initialize on Shopify theme editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new GiveawayPageAnimations();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-spectacular"] && !Shopify.designMode) return;
  try {
    
/**
 * Giveaway Page Interactions
 * Handles scroll reveals, form interactions, and celebration effects
 */
class GiveawayPageAnimations {
  constructor() {
    this.init();
  }

  init() {
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Core initializations
    this.setupScrollReveal();
    this.setupFormEnhancements();
    this.setupCountdown();
    this.initializeParticles();
    this.setupSmoothScroll();
    
    // Trigger hero animations immediately
    this.animateHero();
  }

  /**
   * Animate hero elements on load
   */
  animateHero() {
    if (this.isReducedMotion) return;
    
    const title = document.querySelector('.giveaway-page__title');
    if (title) {
      // Add class to trigger CSS animation
      requestAnimationFrame(() => {
        title.classList.add('animate-in');
      });
    }
  }

  /**
   * Setup Intersection Observer for scroll-triggered reveals
   */
  setupScrollReveal() {
    if (this.isReducedMotion) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          // Stop observing once revealed for performance
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Elements to observe
    const elementsToReveal = document.querySelectorAll([
      '.giveaway-page__apply-highlight',
      '.giveaway-page__step',
      '.giveaway-page__prize-card',
      '.giveaway-page__spec-item'
    ].join(','));

    elementsToReveal.forEach((el, index) => {
      // Add index for staggered delays
      el.style.setProperty('--item-index', index % 4); // Reset index every 4 items
      observer.observe(el);
    });
  }

  /**
   * Enhance form with micro-interactions
   */
  setupFormEnhancements() {
    const form = document.querySelector('.giveaway-page__form-card');
    if (!form) return;

    // Add focus classes for styling hooks
    const inputs = form.querySelectorAll('.field__input, .text-area');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        input.parentElement.classList.add('is-focused');
      });
      
      input.addEventListener('blur', () => {
        input.parentElement.classList.remove('is-focused');
      });
    });

    // Character counter for textarea
    const textarea = form.querySelector('#GiveawayForm-body');
    if (!textarea) return;

    const maxChars = 500; // Assuming 500 char limit
    const counter = document.createElement('div');
    counter.className = 'giveaway-char-counter';
    counter.style.cssText = 'font-size: 12px; margin-top: 4px; text-align: right; transition: color 0.3s;';
    
    const updateCounter = () => {
      const length = textarea.value.length;
      counter.textContent = `${length} characters`;
      
      if (length > maxChars) {
        counter.style.color = 'rgba(255, 59, 48, 0.8)';
      } else if (length > maxChars * 0.8) {
        counter.style.color = 'rgba(255, 149, 0, 0.8)';
      } else {
        counter.style.color = 'rgba(var(--color-foreground, 5, 28, 54), 0.6)';
      }
    };
    
    textarea.addEventListener('input', updateCounter);
    textarea.parentElement.appendChild(counter);
    updateCounter();
  }
  
  /**
   * Setup countdown timer (if deadline exists)
   */
  setupCountdown() {
    const deadlineValue = document.querySelector('.giveaway-page__status-pill--alert .giveaway-page__status-value');
    if (!deadlineValue) return;
    
    // Try to parse the deadline
    const deadlineText = deadlineValue.textContent.trim();
    // This is a simple implementation - you may need to adjust based on your date format
    // Example: "Jan 8 · 11:59pm ET"
    
    // For now, we'll just add a pulsing effect to emphasize urgency
    // A full countdown would require a specific date format
    const pill = deadlineValue.closest('.giveaway-page__status-pill--alert');
    if (pill) {
      // Add urgency class if within 48 hours (you'd calculate this based on actual deadline)
      // pill.classList.add('urgent');
    }
  }
  
  /**
   * Initialize floating particles (desktop only)
   */
  initializeParticles() {
    if (this.isMobile) return;
    
    const background = document.querySelector('.giveaway-page__background');
    if (!background) return;
    
    // Particles are handled via CSS animations on ::before pseudo-element
    // This is more performant than JS-based particle systems
  }
  
  /**
   * Trigger confetti celebration
   */
  triggerConfetti() {
    if (this.isReducedMotion) return;
    
    // Create confetti container
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'giveaway-confetti';
    document.body.appendChild(confettiContainer);
    
    // Confetti colors matching the brand
    const colors = [
      'rgba(1, 219, 243, 0.9)',    // Mad Dad Energy
      'rgba(82, 195, 1, 0.9)',     // Mad Dad Optimism
      'rgba(209, 24, 130, 0.9)',   // Mad Dad Chaos
      'rgba(255, 193, 7, 0.9)',    // Gold
      'rgba(255, 255, 255, 0.9)'   // White
    ];
    
    // Create confetti pieces
    const pieceCount = this.isMobile ? 30 : 50;
    
    for (let i = 0; i < pieceCount; i++) {
      const piece = document.createElement('div');
      piece.className = 'giveaway-confetti__piece';
      
      // Random properties
      const color = colors[Math.floor(Math.random() * colors.length)];
      const left = Math.random() * 100;
      const delay = Math.random() * 0.5;
      const duration = 2 + Math.random() * 2;
      const size = 8 + Math.random() * 8;
      
      piece.style.cssText = `
        --confetti-color: ${color};
        --fall-delay: ${delay}s;
        --fall-duration: ${duration}s;
        left: ${left}%;
        width: ${size}px;
        height: ${size}px;
        border-radius: ${Math.random() > 0.5 ? '50%' : '2px'};
      `;
      
      confettiContainer.appendChild(piece);
    }
    
    // Remove confetti after animation completes
    setTimeout(() => {
      confettiContainer.remove();
    }, 4000);
    
    // Add success celebration class to form status
    const formStatus = document.querySelector('.form-status-list');
    if (formStatus) {
      formStatus.classList.add('success-celebration');
    }
  }
  
  /**
   * Smooth scroll to form when clicking CTA
   */
  setupSmoothScroll() {
    const ctaButtons = document.querySelectorAll('a[href="#GiveawayForm"]');
    ctaButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const form = document.getElementById('GiveawayForm');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Focus first input after scroll
          setTimeout(() => {
            const firstInput = form.querySelector('.field__input');
            firstInput?.focus();
          }, 500);
        }
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new GiveawayPageAnimations();
  });
} else {
  new GiveawayPageAnimations();
}

// Re-initialize on Shopify theme editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new GiveawayPageAnimations();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const MAD_DAD_ANNOUNCEMENT_STORAGE_PREFIX = 'mad-dad-announcement-dismissed-';

  const madDadAnnouncementStorageAvailable = (() => {
    try {
      const testKey = '__mad_dad_announcement__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  })();

  function initializeMadDadAnnouncementBar(rootEl = document, { forceReveal = false } = {}) {
    if (!rootEl || !rootEl.querySelectorAll) return;

    const bars = rootEl.querySelectorAll('[data-mad-dad-announcement]');
    if (!bars.length) return;

    bars.forEach((bar) => {
      const dismissKey = bar.dataset.dismissKey;
      if (!dismissKey) return;

      const messageHash = bar.dataset.messageHash || 'default';
      const storageKey = `${MAD_DAD_ANNOUNCEMENT_STORAGE_PREFIX}${dismissKey}-${messageHash}`;
      const dismissButton = bar.querySelector('[data-announcement-dismiss]');

      if (!dismissButton) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const hideBar = ({ store = true, immediate = false } = {}) => {
        if (store && !forceReveal && madDadAnnouncementStorageAvailable) {
          try {
            window.localStorage.setItem(storageKey, 'true');
          } catch (error) {
            /* no-op */
          }
        }

        const finalizeHide = () => {
          bar.setAttribute('hidden', '');
          bar.classList.add('mad-dad-announcement-bar--hidden');
        };

        if (immediate || prefersReducedMotion.matches) {
          finalizeHide();
          return;
        }

        bar.classList.add('mad-dad-announcement-bar--closing');
        bar.addEventListener('transitionend', finalizeHide, { once: true });
      };

      bar.classList.remove('mad-dad-announcement-bar--hidden', 'mad-dad-announcement-bar--closing');
      bar.removeAttribute('hidden');

      if (!forceReveal && madDadAnnouncementStorageAvailable) {
        try {
          if (window.localStorage.getItem(storageKey) === 'true') {
            hideBar({ store: false, immediate: true });
            return;
          }
        } catch (error) {
          /* no-op */
        }
      }

      if (dismissButton.dataset.madDadAnnouncementBound === 'true') return;

      dismissButton.addEventListener('click', () => {
        hideBar({ store: !forceReveal });
      });
      dismissButton.dataset.madDadAnnouncementBound = 'true';
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const madDadIsDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

  document.addEventListener('DOMContentLoaded', () => {
    initializeMadDadAnnouncementBar(document, { forceReveal: madDadIsDesignMode });
  });

  if (madDadIsDesignMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initializeMadDadAnnouncementBar(event.target, { forceReveal: true });
    });

    document.addEventListener('shopify:section:reorder', () => {
      initializeMadDadAnnouncementBar(document, { forceReveal: true });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
